import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    isSubmitLoading: false
}
export const fetchPreFilledData = createAsyncThunk(
    'outbound/fetchPreFilledData',
    async ({product_manufacturing_id,feasibility_assesment_id,patient_id}, { rejectWithValue }) => {
        try {
            const response = await api.get(`/outbound-form/pre-feeled-data/${patient_id}?feasibility_id=${feasibility_assesment_id}&product_manufacturing_id=${product_manufacturing_id}`);
            return response.data
        } catch (error) {
            notify.error(error ?? error.data.message)
            return rejectWithValue(error?.response ? error?.response?.data?.message : error.message)
        }
    }
);

export const createOutbondForm = createAsyncThunk(
    'outbound/createOutbondForm',
    async (args, { rejectWithValue }) => {
        try {
            const { patient_id, formData } = args
            const response = await api.post(`/outbound-form/save/${patient_id}`, formData);
            notify.success(response.data.message)
            return response.data
        } catch (error) {
            notify.error(error ?? error.data.message)
            return rejectWithValue(error.response ? error.response.data : error.message)
        }
    }
);

export const qaVerificationComment = createAsyncThunk(
    'outbound-form/qa/verification',
    async (args, { rejectWithValue }) => {
        try {
            const { patient_id, formData } = args
            const response = await api.put(`/outbound-form/qa/verification/${patient_id}`, formData);
            notify.success(response.data.message)
            return response.data
        } catch (error) {
            notify.error(error ?? error.data.message)
            return rejectWithValue(error.response ? error.response.data : error.message)
        }
    }
);

export const fetchOutbondDetails = createAsyncThunk(
    'outbound/fetchOutbondDetails',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(`/outbound-form/get-by-subject-id/${id}`);
            return response.data
        } catch (error) {
            notify.error(error ?? error.data.message)
            return rejectWithValue(error.response ? error.response.data : error.message)
        }
    }
);

export const updateOutbondForm = createAsyncThunk(
    'outbound/updateOutbondForm',
    async (args, { rejectWithValue }) => {
        try {
            const { patient_id,id, formData } = args
            const response = await api.put(`/outbound-form/save/${patient_id}/${id}`, formData);
            notify.success(response.data.message)
            return response.data
        } catch (error) {
            notify.error(error ?? error.data.message)
            return rejectWithValue(error.response ? error.response.data : error.message)
        }
    }
);



const outboundSlice = createSlice({
    name: "outbound",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPreFilledData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchPreFilledData.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchPreFilledData.rejected, (state) => {
                state.isLoading = false;
            })
        builder
            .addCase(createOutbondForm.pending, (state) => {
                state.isSubmitLoading = true;
            })
            .addCase(createOutbondForm.fulfilled, (state) => {
                state.isSubmitLoading = false;
            })
            .addCase(createOutbondForm.rejected, (state) => {
                state.isSubmitLoading = false;
            })
        builder
            .addCase(updateOutbondForm.pending, (state) => {
                state.isSubmitLoading = true;
            })
            .addCase(updateOutbondForm.fulfilled, (state) => {
                state.isSubmitLoading = false;
            })
            .addCase(updateOutbondForm.rejected, (state) => {
                state.isSubmitLoading = false;
            })
        builder
            .addCase(fetchOutbondDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchOutbondDetails.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchOutbondDetails.rejected, (state) => {
                state.isLoading = false;
            })
    }
})

export const selectIsLoading = (state) => state.outbound.isLoading;
export const selectIsSubmitLoading = (state) => state.outbound.isSubmitLoading;

export default outboundSlice.reducer;